import React, { Component } from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import styled from "styled-components";

const TableStyle = styled.div`
  th {
    font-size: 0.9rem;
  }
  td {
    font-size: 0.85rem;
    text-transform: capitalize;
  }
  @media screen and (max-width: 375px) {
    .pivoted {
      margin: 25px 0;
      div {
        white-space: normal !important;
      }
    }
  }
`;
class StudentTable extends Component {
  render() {
    return (
      <TableStyle>
        <Table className="table table-bordered">
          <Thead>
            <Tr>
              {this.props.headers.map((header, index) => (
                <Th scope="col" key={index}>
                  {header}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {this.props.data.map((value, valueIndex) => (
              <Tr key={valueIndex}>
                {Object.keys(value).map(key => (
                  <Td key={key}>{value[key] || "N/A"}</Td>
                ))}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableStyle>
    );
  }
}

export default StudentTable;
